var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    display: 'flex',
    flexDirection: _vm.vertical ? 'column' : 'row',
  })},_vm._l((_vm.Menu),function(item,idx){return _c('router-link',{key:idx,attrs:{"to":item.path}},[_c('button',{staticClass:"app-btn",class:[{ active: _vm.$route.path === item.path }],staticStyle:{"text-transform":"none"}},[_vm._v(" "+_vm._s(item.name)+" ")])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }